/**
 * DividerSection — styled horizontal rule with configurable style, spacing, width.
 */

const SPACING_MAP = { sm: '0.5rem', md: '1rem', lg: '2rem', xl: '3.5rem', none: '0' };

export default function DividerSection({ config }) {
  const {
    style: divStyle = 'solid',
    color = null,
    thickness = 1,
    width = '80',
    spacing_top = 'md',
    spacing_bottom = 'md',
  } = config || {};

  if (divStyle === 'blank') {
    return (
      <div
        style={{
          marginTop: SPACING_MAP[spacing_top] || '1rem',
          marginBottom: SPACING_MAP[spacing_bottom] || '1rem',
        }}
      />
    );
  }

  const borderColor = color || 'var(--primary-color)';
  const widthPct = isNaN(width) ? width : `${width}%`;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: SPACING_MAP[spacing_top] || '1rem',
        marginBottom: SPACING_MAP[spacing_bottom] || '1rem',
      }}
    >
      {divStyle === 'gradient' ? (
        <div
          style={{
            width: widthPct,
            height: `${thickness}px`,
            background: `linear-gradient(to right, transparent, var(--primary-color), transparent)`,
          }}
        />
      ) : (
        <hr
          style={{
            width: widthPct,
            margin: 0,
            borderTop: `${thickness}px ${divStyle} ${borderColor}`,
          }}
        />
      )}
    </div>
  );
}
